export const unidades = {
  pergunta: "Qual unidade você tem interesse de atendimento?",
  options: [
    { id: "68c84a3b54ff4cb7c66b5848", label: "Alagoinhas" },
    { id: "658ced8a9a8cfe6417c1cca3", label: "Camaçari" },
    { id: "6145edfc5a9c21d1f3332bde", label: "Candeias" },
    { id: "68680b784d13004f2e23a0d0", label: "Cruz das Almas" },
    { id: "6667a23549d3a8cbf45687a5", label: "Feira de Santana" },
    { id: "6667a23549d3a8cbf45687a5", label: "Santa Bárbara" },
    { id: "685d54e91f453ce8b394c3cc", label: "Jequié" },
    { id: "6ae163c3d5b81e94bff672cc", label: "Ipiaú" },
    { id: "642ed08ff9247f7dc411e3b3", label: "Lauro de Freitas" },
    { id: "6151c8fb87c3563e2518c648", label: "Salvador – Cajazeiras" },
    { id: "64c865d5be86332c791ae293", label: "Salvador - Nazaré" },
    { id: "64c865d5be86332c791ae293", label: "Ilha de Itaparica" },
    { id: "68680e614d13004f2e23a0d1", label: "São Sebastião do Passé" },
    { id: "69129577bb7e7003b4e5178f", label: "Vitória da Conquista" },
  ]
}